<script>
  import Contact2 from './contact2.svelte'
</script>

<section class="hero">
  <div class="lantern">
    <img class="lamp" src="../assets/images/lamp.png" alt="ok" />
  </div>

  <div class="hero-text">
    <Contact2 />
  </div>

  <div class="gop">
    <!-- Hanging mATERIALS -->
    <img class="amman" src="../assets/images/amman.png" alt="ok" />
    <img class="gopM" src="../assets/images/gop.png" alt="ok" />
  </div>
</section>

<style lang="scss">
  @font-face {
    font-family: 'H1Font';
    src: url('../assets/fonts/vinque.ttf');
  }

  .gop {
    .amman {
      position: relative;
      width: 200px;
      transform: translate(50%, 130px);
      z-index: 1;
    }

    .gopM {
      transform: translate(-50%, 0px);
    }

    @media only screen and (max-width: 700px) {
      height: 0vh;
      transform: translate(50vw, -50vh);
    }
  }
  .hero {
    width: 100vw;
    min-height: 100vh;
    display: grid;
    grid-template-columns: 4fr 3fr 4fr;
    background-image: url('../assets/images/bg.jpg');

    @media only screen and (max-width: 700px) {
      grid-template-columns: 10fr;

      div {
        img {
          width: 100%;
        }
      }

      .hero-text {
        height: 100vh;
        z-index: 1;
      }
    }

    .lantern {
      @media only screen and (max-width: 700px) {
        display: none;
      }
    }
    div {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 60%;
      }

      .lamp {
        width: auto;
        height: 100vh;
      }

      h1 {
        font-family: 'H1Font';
        text-align: center;
        color: rgb(37, 37, 37);
      }
    }

    .hero-text {
      flex-direction: column;

      p {
        background-color: #ff9933;
        padding: 5px 15px;
        border-radius: 5px;
        font-weight: bold;
        color: #fff;
      }
    }
  }
</style>
